export const setDemanda = (productos) => {
    return function (dispatch) {
        dispatch(setProductos(productos));
    }
}

const setProductos = (productos) => ({
    type: "SET_DEMANDA",
    ...productos
});